// extracted by mini-css-extract-plugin
module.exports = {"internalLinkHeading":"InstitutionTemplate_internalLinkHeading__IEQLI","internalLinksCta":"InstitutionTemplate_internalLinksCta__l_3WP"};